export const CANCELLATION_REASONS = [
  {
    value: "consignor_needed_for_own_use",
    text: "Consignor Needed For Own Use"
  },
  { value: "consignor_sold", text: "Consignor Sold" },
  { value: "consignor_grew_impatient", text: "Consignor Grew Impatient" },
  { value: "consignment_cancelled_by_us", text: "Consignment Cancelled By Us" },
  { value: "unknown", text: "Unknown/Other" }
];



// WEBPACK FOOTER //
// ./app/modules/Consignments/constants.js